@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.content {
  width: 100%;

  &--centered {
    display: flex;
    justify-content: center;
  }

  &__spacer {
    height: 0;
  }
}

.button-back--position {
  position: absolute;
  left: 0;
  bottom: 0;
  margin: 5.6875rem 30%;

  @media (max-width: map.get($grid-breakpoints, xl)) {
    margin: 5.6875rem 20%;
  }

  @media (max-width: map.get($grid-breakpoints, lg)) {
    margin: 5.6875rem 10%;
  }
}

.button-forward--position {
  // position: absolute;position
  // bottom: 0rem;bottom
  place-self: flex-end flex-end;
  margin: 2rem 30% 5.6875rem 0;

  @media (max-width: map.get($grid-breakpoints, xl)) {
    margin: 2rem 20% 5.6875rem 0;
  }

  @media (max-width: map.get($grid-breakpoints, lg)) {
    margin: 2rem 10% 5.6875rem 0;
  }
}

.error-message {
  margin-top: 2rem;
  font-size: 1.5rem;
  line-height: 150%;

  @media (max-width: map.get($grid-breakpoints, md)) {
    margin-top: 1rem;
    font-size: 0.75rem;
  }

  &--white {
    color: #fff;
  }
}

.wrapper-inner--no-margin {
  margin: 0;
}

.content-wrapper--extra-content {
  margin-top: 3rem;

  @media (max-width: map.get($grid-breakpoints, md)) {
    margin-top: 1.5rem;
  }
}

.wrapper-top-row--few-options {
  margin-bottom: 10rem;

  @media (max-width: map.get($grid-breakpoints, lg)) {
    margin-bottom: 8.9rem;
  }
}
